const appVersion = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0";
let monitoringEnabled = false;
let reporting = false;

function normalizedError(error) {
  if (error instanceof Error) {
    return {
      message: error.message || "Bilinmeyen hata",
      code: error.code || error.name || ""
    };
  }
  return {
    message: typeof error === "string" ? error : "Bilinmeyen hata",
    code: ""
  };
}

export async function captureError(error, context = "window-error") {
  console.error(`[${context}]`, error);
  if (!monitoringEnabled || reporting) return;

  const normalized = normalizedError(error);
  reporting = true;
  try {
    const { reportClientError } = await import("./functions-service.js");
    await reportClientError({
      ...normalized,
      context,
      appVersion,
      path: window.location.pathname
    });
  } catch {
    // Hata izleme, asıl uygulama akışını hiçbir zaman kesmemelidir.
  } finally {
    reporting = false;
  }
}

export function enableMonitoring() {
  if (monitoringEnabled) return;
  monitoringEnabled = true;

  window.addEventListener("error", event => {
    captureError(event.error || event.message, "window-error");
  });

  window.addEventListener("unhandledrejection", event => {
    captureError(event.reason, "unhandled-rejection");
  });
}
